import { IPredicate } from '@src/models/api';
import { AnyType } from '@src/models/common';

import { TControllerValue, TDateRange, TFilter, TFilterScheme, TFilterValues } from '../models';
import { DEFAULT_FILTER_OPERATORS_MAP } from './consts';

/** Получаем предикаты из списка фильтров */
export const getPredicateFromValue = (values: Map<string, TControllerValue>, scheme: Map<string, TFilter>) => {
  const predicate: IPredicate[] = [];

  Array.from(values).forEach(([name, v]) => {
    const filter = scheme.get(name);
    const value = v?.value;
    if (!filter) return;

    /** Общая проверка значений */
    if (typeof value === 'undefined' || value === null || (Array.isArray(value) && value.length === 0)) return;

    if (typeof filter.getPredicate === 'function') {
      predicate.push(...filter.getPredicate(value));
      return;
    }
    //Изменение оператора не работает для dateRange
    const operator = filter?.operator || DEFAULT_FILTER_OPERATORS_MAP[filter.type];
    switch (filter.type) {
      case 'string':
        predicate.push({ field: name, operator: operator, values: [String(value)] });
        break;

      case 'options':
        predicate.push({ field: name, operator: operator, values: (value as AnyType[]).map((o) => o.id) });
        break;

      case 'boolean':
        predicate.push({ field: name, operator: operator, values: [String(value)] });
        break;

      case 'dateRange':
        const [first, second] = value as TDateRange;
        typeof first === 'string' &&
          predicate.push({ field: name, operator: 'GREATER_THAN_EQUALS', values: [String(first)] });
        typeof second === 'string' &&
          predicate.push({ field: name, operator: 'LESS_THAN_EQUALS', values: [String(second)] });
        break;

      default:
        break;
    }
  });

  return predicate;
};

export const getFilterValue = (map: Map<string, TControllerValue>, name) => {
  return map.get(name) || {};
};

export const getValueFromPredicate = (p: IPredicate[], scheme: Map<string, TFilterScheme>) => {
  const map = new Map<string, TFilterValues>();
  if (!Array.isArray(p) || (Array.isArray(p) && p.length === 0)) return map;

  p.forEach((p) => {
    const filter = scheme.get(p.field);

    if (!filter) return;

    switch (filter.type) {
      case 'string':
        map.set(filter.name, p.values ? p.values[0] : '');
        break;

      case 'boolean':
        map.set(filter.name, p.values[0] === 'false' ? false : Boolean(p.values[0]));
        break;

      case 'options':
        map.set(
          filter.name,
          p.values.map((id) => ({ id })),
        );
        break;

      case 'dateRange':
        const prevValue = map.get(filter.name) || [null, null];
        if (p.operator === 'GREATER_THAN' || p.operator === 'GREATER_THAN_EQUALS') {
          prevValue[0] = p.values[0];
        }

        if (p.operator === 'LESS_THAN' || p.operator === 'LESS_THAN_EQUALS') {
          prevValue[1] = p.values[0];
        }

        map.set(filter.name, prevValue);
        break;

      default:
        break;
    }
  });

  return map;
};
